<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in tabs"
          :key="item.name"
          class="divider font-black"
          @click="load(item.id)"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item class="pb-12">
          <probation-pending-container-view ref="pending" />
        </v-tab-item>
     
        <v-tab-item class="pb-12">
          <probation-completed-container-view ref="completed" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      ProbationPendingContainerView: () => import('@/components/hris/probation/pending/ContainerView'),
      ProbationCompletedContainerView: () => import('@/components/hris/probation/completed/ContainerView'),
    },
  
    data () {
      return {
        tabs: [
          { id: 1, name: 'Pending Action' },
          { id: 2, name: 'Completed' },
        ],
        active: 0,    
      }
    },

    methods: {
      load (tabId) {
        if (tabId === 1) {
          this.$refs.pending.loadProbations()
        } else {
          this.$refs.completed.loadCompletedProbations()
        }
      },  
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
